<script setup lang="ts">
const slots = useSlots()

const hasContent = computed(() => {
    return !!(slots.title || slots.text || slots.default)
})
</script>

<template>
    <div v-if="hasContent" class="footer">
        <div v-if="slots.title" class="footer-title">
            <slot name="title" />
        </div>

        <div v-if="slots.text" class="footer-text">
            <slot name="text" />
        </div>

        <slot />
    </div>
</template>

<style lang="scss" scoped>
.footer {
    max-width: 350px;
    margin: 30px auto;
    text-align: center;

    @include tablet(md) {
        margin-top: 50px;
    }

    &-title {
        font-size: $font-size-lg;
        font-weight: $text-bold;
    }
}
</style>
